<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="country_master_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Country</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Country</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <!-- <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="country_super_master_list_name"
                      v-model="editedItem.country"
                      item-text="country_super_master_list_id"
                      item-value="id"
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: India, Malaysia, Nepal':'noneditable'"
                      :filled="editedIndex==-1?false:true"
                      label="Country"
                      :error="errorMsg.country?true:false"
                      :error-messages="errorMsg.country?'Required':''"
                    ></v-select>
                  </v-col> -->
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="country_super_master_list_name"
                                                        v-model="addedItem.country_super_master_list_name"
                                                        item-text = "name"
                                                        return-object
                                                        label="Select Country"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.country" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="
                              editedIndex == -1
                                ? 'For example ::India, SriLanka, China '
                                : 'noneditable'
                            " label="Country" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <!-- <v-col cols="12" sm="12" md="12"  v-if='editedIndex == -1'>	
	                    <v-autocomplete	
	                    :items="country_super_master_list_nationality"
                      v-model="addedItem.country_super_master_list_nationality"
	                    label="Select Nationality"	
	                    ></v-autocomplete>	
	                </v-col> -->
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.nationality" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="
                              editedIndex == -1
                                ? 'For example ::Indian, American, British'
                                : 'noneditable'
                            " label="Nationality"></v-text-field>
                                                </v-col>

                                                <!-- <v-col cols="8" sm="8" md="8">
                    <v-select
                      :items="country_super_master_list_nationality"
                      v-model="editedItem.nationality"
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Indian, American, British':'For example :: Indian, American, British'"
                      label="Nationality"
                    ></v-select>
                  </v-col> -->
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field label="Nationality Name" v-model="addedItem.country_super_master_list_name.nationality" v-if="editedIndex == -1"></v-text-field>
                                                </v-col>
                                        </v-row>
                                            <!-- Unicode Country and Nationality Fields -->
                                            <v-row>
                                                <!-- Unicode Country Name -->
                                                <v-col cols="12" class="my-2">
                                                    <v-text-field
                                                        label="Unicode Country Name"
                                                        v-model="addedItem.country_super_master_list_name.unicode_name"
                                                        dense
                                                        hide-details
                                                        v-if="editedIndex == -1"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Unicode Country Name"
                                                        v-model="editedItem.unicode_country"
                                                        dense
                                                        hide-details
                                                        v-if="editedIndex != -1"
                                                    ></v-text-field>
                                                </v-col>

                                                <!-- Unicode Nationality Name -->
                                                <v-col cols="12" class="my-2">
                                                    <v-text-field
                                                        label="Unicode Nationality Name"
                                                        v-model="addedItem.country_super_master_list_name.unicode_nationality"
                                                        dense
                                                        hide-details
                                                        v-if="editedIndex == -1"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        label="Unicode Nationality Name"
                                                        v-model="editedItem.unicode_nationality"
                                                        dense
                                                        hide-details
                                                        v-if="editedIndex != -1"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>


                                            <v-row>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col v-if="editedIndex == -1">
                                                    <v-checkbox dense v-model="newcheckbox" color="success"
                                                        label="Country not present in above list? Add new here..."></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12"
                                                    v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field v-model.trim="newcountry" persistent-hint
                                                        hint="For example :: India, Afghanistan, Austria, China"
                                                        label="New Country" ref="newcountry"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12"
                                                    v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field v-model.trim="newnationality" persistent-hint
                                                        hint="For example :: Indian, Afghan, Austrian, Chinese"
                                                        label="New Nationality" ref="newnationality"></v-text-field>
                                                </v-col>        
                                            </v-row>
                                            <v-row>
                                                    <v-col v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field label="New Country Unicode" v-model="unicode_new_country"></v-text-field>
                                                </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field label="New Nationality Unicode" v-model="unicode_new_nationality"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" v-if="newcheckbox">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="saveNewCountry">Save New Country</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            country_super_master_list_name: "",
            // country_super_master_list_nationality: '',
            overlay: false,
            errorMsg: {
                country: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            newcountry: "",
            newnationality: "",
            unicode_new_nationality:"",
            unicode_new_country:"",
            newcheckbox: false,
            country_super_master_list: null,
            // extraBreadcrumbItems: [
            //     { text: "Country Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style2",
            headers: [
                {
                    text: "Country",
                    align: "left",
                    sortable: false,
                    value: "country",
                },
                {
                    text: "Nationality",
                    align: "left",
                    sortable: false,
                    value: "nationality",
                },
                {
                    text: "Country In Unicode",
                    align: "left",
                    sortable: false,
                    value: "unicode_country",
                },
                {
                    text: "Nationality In Unicode",
                    align: "left",
                    sortable: false,
                    value: "unicode_nationality",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            country_master_list: [],
            editedIndex: -1,
            addedItem: {
                country_super_master_list_name: "",
                //country_super_master_list_nationality: '',
            },
            editedItem: {
                id: "",
                country: "",
                nationality: "",
                unicode_nationality:"",
                unicode_country:"",
                isactive: true,
            },
            defaultItem: {
                id: "",
                country: "",
                nationality: "",
                unicode_nationality:"",
                unicode_country:"",
                isactive: true,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Country" : "Edit Country";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            //   initialize () {

            //   },
                       hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            saveNewCountry() {
                if (this.newcountry == null || this.newcountry == "") {
                    if (this.newnationality == null || this.newnationality == "") 
                    if(this.hasWhiteSpace(this.newcountry))
                    if(this.hasWhiteSpace(this.newnationality))
                    
                    this.showSnackbar("#b71c1c", "Please add country!");
                    this.$refs["newcountry"].focus();
                    this.$refs["newnationality"].focus();
                    return;
                }
                let data = {
                    newcountry: this.newcountry,
                    newnationality: this.newnationality,
                    unicode_new_nationality : this.unicode_new_nationality,
                    unicode_new_country : this.unicode_new_country
                };
                // alert(this.newnationality)

                this.overlay = true;
                axios
                    .post("/AdmissionMaster/addNewCountry", data)
                    .then((res) => {
                        (this.newcountry = ""), (this.newnationality = ""), (this.newcheckbox = false), (this.overlay = false);
                        if (res.data.status.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Category Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "Category Already Present!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
                this.close();
            },

            editItem(item) {
                this.editedIndex = this.country_master_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/country")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)

                            if ((this.load = true)) {
                                this.overlay = false;
                                this.country_master_list = res.data.country_master_list;
                                this.country_super_master_list_name = res.data.country_super_master_list_name;
                                // this.country_super_master_list_nationality=res.data.country_super_master_list_nationality
                            }
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            // deleteItem (item) {
            //   const index = this.country_master_list.indexOf(item)
            //   confirm('Are you sure you want to delete this item?') && this.country_master_list.splice(index, 1)
            // },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
                this.newcheckbox = false;
                this.newcountry = "";
                this.newnationality = "";
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/editCountry", this.editedItem)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    //window.alert(res.data.msg)
                                    Object.assign(this.country_master_list[this.editedIndex], this.editedItem);
                                }
                                this.showSnackbar("#4caf50", "Country Updated Successfully..."); // show snackbar on success
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                        this.close();
                    }
                } else {
                    //this.country_master_list.push(this.editedItem)
                    axios
                        .post("/AdmissionMaster/saveCountry", this.addedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                //window.alert(res.data.status.code)
                                this.country_master_list.push(this.addedItem);
                                this.showSnackbar("#4caf50", "Country Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                //window.alert(res.data.status.code)
                                //alert(res.data.status.message)
                                this.showSnackbar("#b71c1c", "Country Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }, //save()
            isValidated() {
                if (this.editedItem.country) {
                    return true;
                } else {
                    if (!this.editedItem.country) {
                        this.errorMsg.country = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>

